import { render, staticRenderFns } from "./stationMain.vue?vue&type=template&id=54305e8c&scoped=true"
import script from "./stationMain.vue?vue&type=script&lang=js"
export * from "./stationMain.vue?vue&type=script&lang=js"
import style0 from "./stationMain.vue?vue&type=style&index=0&id=54305e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54305e8c",
  null
  
)

export default component.exports